import {
    DataSource,
    Layout,
    LayoutHeader,
    Table
} from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlList extends Layout {
    sourceMCControl: DataSource;
    layoutheaderTitle: LayoutHeader;
    tableMobileCommControlList: Table;
}
